import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "socialWhatsapp"
const SocialWhatsappIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path d="M13.413 13.275c.29-.365.484-.547.58-.547.097 0 .46.163 1.088.49.63.328.962.525 1 .592a.476.476 0 0 1 .022.168c0 .245-.064.528-.19.848-.12.29-.383.534-.792.73-.41.198-.79.297-1.139.297-.424 0-1.13-.231-2.12-.692a6.37 6.37 0 0 1-1.898-1.317c-.535-.543-1.086-1.232-1.652-2.065-.535-.796-.8-1.518-.792-2.165v-.09c.022-.677.298-1.264.826-1.763a.844.844 0 0 1 .58-.245c.045 0 .112.005.201.016.09.012.16.017.212.017.142 0 .24.024.296.073.056.048.114.15.173.307.06.148.182.476.368.982s.28.785.28.837c0 .156-.129.37-.386.642-.256.271-.385.444-.385.518a.32.32 0 0 0 .056.168c.253.543.633 1.053 1.138 1.529.417.394.979.77 1.686 1.127.089.052.17.078.245.078.112 0 .313-.178.603-.535zm-1.685 5.368a6.82 6.82 0 0 0 2.717-.558 7.068 7.068 0 0 0 2.238-1.496 7.068 7.068 0 0 0 1.496-2.237 6.82 6.82 0 0 0 .558-2.718 6.82 6.82 0 0 0-.558-2.718 7.068 7.068 0 0 0-1.496-2.237 7.068 7.068 0 0 0-2.238-1.496 6.82 6.82 0 0 0-2.717-.558 6.82 6.82 0 0 0-2.718.558 7.068 7.068 0 0 0-2.238 1.496 7.068 7.068 0 0 0-1.495 2.237 6.82 6.82 0 0 0-.558 2.718c0 1.51.446 2.88 1.339 4.107l-.882 2.6 2.701-.859a6.863 6.863 0 0 0 3.85 1.16zM8.458 3.888a8.217 8.217 0 0 1 3.27-.67c1.138 0 2.226.224 3.264.67a8.5 8.5 0 0 1 2.684 1.797 8.5 8.5 0 0 1 1.797 2.684 8.177 8.177 0 0 1 .67 3.265 8.177 8.177 0 0 1-.67 3.264 8.5 8.5 0 0 1-1.797 2.685 8.5 8.5 0 0 1-2.684 1.796 8.177 8.177 0 0 1-3.264.67c-1.451 0-2.81-.35-4.074-1.049L3 20.496l1.518-4.52a8.214 8.214 0 0 1-1.205-4.342c0-1.138.223-2.227.67-3.265a8.5 8.5 0 0 1 1.796-2.684 8.516 8.516 0 0 1 2.679-1.797z" />
        </svg>
      }
    </span>
  )
}
export default SocialWhatsappIcon
